<style lang="scss">
.m2_order_closeTip {
   .right_container {
    background-color: white;
    padding: 30px;
    border-radius: 20px 20px 0 0;
  }
  .close-tip {
    margin-top: 200px;
    padding: 10px 0;
    text-align: center;
    .msg {
      margin-top: 40px;
      color: #333333;
    }
  }
}

</style>
<template>
  <div class="m2_container m2_order_closeTip">
    <m2Sidebar activeIndex="9-1"></m2Sidebar>
    <div class="right_container">
      <div class="close-tip">
        <div class="ico">
          <img src="../../assets/images/closeTip.png" />
        </div>
        <div class="msg">
          <p>预约暂未开放，暂时不能进行预约操作。</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
import m2Sidebar from "@components/sidebar/m2_sidebar";
export default {
  components: {
    m2Sidebar: m2Sidebar
  },
 
};
</script>

